/**
 * We take the approach of organizing each “cast member” in a scene within its own file.
 * This is a choice and isn’t required, but it does isolate internal changes/enhancements
 * to these specific “characters.”
 */
import { TorusKnotGeometry, MeshToonMaterial, Mesh, Group } from 'three'
import FlatCoral from './flatcoral'
import Clam from './clam'
import SeaKelp from './seakelp'

/**
 * The use of a JavaScript “class” is also a design choice.
 */
class CoreInhabitants {
  constructor() {
    this.group = new Group()
    this.materials = []

    this.geometry = new TorusKnotGeometry( 0.6, 0.4, 24, 5, 3, 4 );
    this.coreMaterial = new MeshToonMaterial({ color: 0xbaa26c });
    this.materials.push(this.coreMaterial)
    this.mesh1 = new Mesh(this.geometry, this.coreMaterial);
    this.mesh2 = new Mesh(this.geometry, this.coreMaterial);
    this.mesh2.rotation.x = Math.PI / 2;

    this.clam = new Clam()
    this.clam.group.position.set(-1.17,0,0)
    this.clam.group.rotation.z = 3.2
    this.materials = [...this.materials, ...this.clam.materials]

    const coralgroup = new Group()
    const kelpgroup = new Group()

    function populate(color, max, scale, height, thickness, materials) {
      for( let i = 0; i < max; i++ ) {
        let newcoral = new RoundCoral( color, 0, height, 0, thickness )
        newcoral.group.scale.set( scale, scale, scale )
        randomize(newcoral)
        coralgroup.add(newcoral.group)
        materials = [...materials, ...newcoral.materials]
      }
      return materials
    }

    function populateFlat(color, max, scale, x, y, thickness, materials) {
      for( let i = 0; i < max; i++ ) {
        let flatcoral = new FlatCoral( color, x, y, 0, thickness )
        flatcoral.group.scale.set( scale, scale, scale )
        randomize(flatcoral)
        coralgroup.add(flatcoral.group)
        materials = [...materials, ...flatcoral.materials]
      }
      return materials
    }

    function populateKelp(max, scale, materials) {
      const position = Math.random() * 100
      for( let i = 0; i < max; i++ ) {
        let kelp = new SeaKelp()
        kelp.group.scale.set( scale, scale, scale )
        randomizeKelp(position, kelp)
        kelpgroup.add(kelp.group)
        materials = [...materials, ...kelp.materials]
      }
      return materials
    }

    function randomize(type) {
      const random = Math.random()
      type.group.rotation.x = random < 0.95 ? (10 + (Math.random() * 100)): (3 + (Math.random() * 10))
      type.group.rotation.z = random < 0.95 ? (10 + (Math.random() * 100)): (3 + (Math.random() * 10))
      type.group.rotation.y = random < 0.95 ? (10 + (Math.random() * 100)): (3 + (Math.random() * 10))
    }

    function randomizeKelp(position, kelp) {
      kelp.group.rotation.x = (position + Math.random() * 0.5)
      kelp.group.rotation.y = (position + Math.random() * 0.5)
      kelp.group.rotation.z = (position + Math.random() * 1)
    }

    this.materials = populate(0xE76149, 6, .056, 19, 1, this.materials)  //light pink
    this.materials = populate(0xFE4E4E, 6, .054, 20, 1.2, this.materials)  // pink FE7F4E
    this.materials = populate(0xB73D23, 6, .054, 20, 1.2, this.materials)  // orange pink
    this.materials = populate(0xB72327, 4, .054, 20, 1, this.materials)  //dark pink
    this.materials = populate(0xB6B254, 4, .044, 26, 1, this.materials)  //yellow
    this.materials = populate(0x455A3C, 4, .044, 26, 1, this.materials)  // light green
    this.materials = populateFlat(0x911717, 2, .082, -1, -.8, 1, this.materials) //big dark pink
    this.materials = populateFlat(0x22142F, 2, .085, 1.1, 0, 1.1, this.materials) //big purple
    this.materials = populateFlat(0x053708, 2, .085, 0, 1, 1, this.materials)  //big dark green
    for (let i = 0; i < 7; i++) {
      this.materials = populateKelp(2 + Math.ceil(Math.random() * 3), .5, this.materials)
    }

    this.coralgroup = coralgroup
    this.kelpgroup = kelpgroup

    this.group.add(
      this.mesh1,
      this.mesh2,
      this.coralgroup,
      this.kelpgroup,
      this.clam.group
    )

  }
}

class RoundCoral {
  constructor(color, x, y, z, thickness) {
    this.group = new Group()
    this.materials = []
    var rotate = 0
    for (let i = 0; i < 3; i++) {
      const newcoral = new FlatCoral( color, x,y,z, thickness )
      newcoral.group.scale.set(1,1, thickness)
      newcoral.group.rotateY(rotate)
      this.group.add(newcoral.group)
      this.materials = [...this.materials, ...newcoral.materials]
      rotate += 20
    }
  }
}


export default CoreInhabitants
